module.exports = __webpack_public_path__ + "img/banner-verify.6519b2e8.png";